import { useStore } from 'features/ListBuilder/infra/react/ListBuilderStore/useStore'

export const useBuildTotalCount = () =>
  useStore(store => store.buildTotal)
